<template>
  <div class="the-tax-settings" v-loading="isLoading">
    <h3>Налаштування комісії для kindchallenge</h3>
    <el-row :gutter="20">
      <el-col :span="12">
        <p>Чи брати комісію</p>
        <el-switch
          v-model="taxSettings.enabled"
          active-text="Так"
          inactive-text="Ні">
        </el-switch>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <p>Вкажіть процент комісії</p>
        <el-slider
          v-model="taxSettings.percent"
          :step="0.5"
          :marks="marks"
          :disabled="!taxSettings.enabled"></el-slider>
      </el-col>
    </el-row>
    <el-divider></el-divider>
    <el-button type="success" @click="handleChange">
      Зберегти
    </el-button>
  </div>
</template>

<script>
/**
 * Component: the-tax-settings - Компонент настройки поддерживаемых приложениям языков
 *
 * @version 1.0.0
 */

import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'the-tax-settings',

  data() {
    return {
      marks: {
        0: '0%',
        50: '50%',
        100: '100%',
      },
    };
  },

  computed: {
    ...mapGetters({
      taxSettings: 'tax/taxSettings',
      isLoading: 'tax/isTaxSettingsLoading',
    }),
  },

  async created() {
    await this.getTaxSettings();
  },

  methods: {
    ...mapActions({
      getTaxSettings: 'tax/getKindchallengeTaxRate',
      setTaxSettings: 'tax/setKindchallengeTaxRate',
    }),
    handleChange() {
      this.setTaxSettings(this.taxSettings);
    },
  },
};
</script>

<style lang="scss">
@import '~@/scss/styles';

.the-tax-settings {
  $this: &;
}
</style>
